module.exports = __webpack_public_path__ + "fonts/pdf.8acc3f55.ttf";